import { graphql } from "gatsby";
import React, { useEffect, useRef, useState } from "react";

import heroImgPlaceholder from "images/volunteer/hero-img.png";

import FindProgramPage from "../components/find-program-page";
import ApplicationForm from "../components/forms/applicationForm";
import Layout from "../components/layout";
import Newsletter from "../components/newsletter";
import Seo from "../components/seo";
import Hero from "../components/shared/hero";
import { ThemeContext } from "../context/ThemeContext";
import { useBannerDetails } from "../hooks/useBannerManager";

export default function ApplicationFormPage(props) {
  const [isNoProgram, setIsNoProgram] = useState(true); // true when url is aplication form url with no program. And when reach out a program page.
  const [groupInstituteSource, setGroupInstituteSource] = useState("");
  const [, setGroupInstituteProductId] = useState("");
  const [, setGroupInstitute] = useState(false);
  const [preselectedProgramType, setPreselectedProgramType] = useState("");
  const [preselectedProgramFocus, setPreselectedProgramFocus] = useState("");
  const [preselectedProgramLocation, setPreselectedProgramLocation] =
    useState("");

  const { data, location } = props;
  const page = data?.page;
  const details = location?.state || {};
  const acfLandingPage = page?.acfLandingPage;

  const heroRef = useRef(null);
  const heroBackgroundImage =
    page?.globalConfig &&
    page?.globalConfig?.backgroundImage &&
    page?.globalConfig?.backgroundImage?.localFile &&
    page?.globalConfig?.backgroundImage?.localFile?.extension
      ? page?.globalConfig.backgroundImage.localFile.publicURL
      : page?.globalConfig &&
          page?.globalConfig?.backgroundImage &&
          page?.globalConfig?.backgroundImage?.sourceUrl
        ? page?.globalConfig?.backgroundImage?.sourceUrl
        : heroImgPlaceholder;
  const heroBackgroundVideo =
    page?.globalConfig && page?.globalConfig?.backgroundVideoJw
      ? page?.globalConfig?.backgroundVideoJw
      : "";
  const appformStep = 0;

  const heroOverlayTitle = "Find a program";
  const heroClassName = "h-105 xxxs:h-72 xxs:h-85 sm:h-94 application-hero";

  const banner = useBannerDetails(page?.slug);

  const enquireUKCardDetails = {
    footerTitle: banner?.title ?? "",
    footerSubtitle: banner?.desc ?? "",
    footerImage: banner?.image || null,
    cardBookDesc: "",
    enquireNowCtaTitle: "Enquire",
    footerCtaTitle: "Apply",
    footerSubtitleClass: "text-sm dark:text-white text-black-lighter",
    contentContainerClass: "sm:w-2/5",
    cardBookDescSpanClass:
      "text-xs font-semibold text-left sm:font-normal dark:text-white text-generic-text",
    applicationFormLink: null,
    enquireNowLink: null,
    enquireBtn: true,
    allowCookieControl: false,
    displayCloseButton: false,
    heroRef: heroRef
  };

  useEffect(() => {
    let locationURL = new URL(location?.href);

    if (locationURL?.search) {
      setIsNoProgram(
        locationURL?.search?.includes("group_source") ||
          (locationURL?.search?.includes("program_type") &&
            [("program", "program_id", "program_code")].every(
              (param) => !locationURL?.search?.includes(param)
            )) ||
          locationURL?.search?.includes("program_location") ||
          locationURL?.search?.includes("program_focus")
      );
    }

    setGroupInstituteProductId(
      locationURL?.searchParams?.get("group_institute")
    );
    setGroupInstitute(locationURL?.search?.includes("group_institute"));

    setGroupInstituteSource(locationURL?.search?.includes("group_source"));

    setPreselectedProgramType(locationURL?.searchParams?.get("program_type"));
    setPreselectedProgramFocus(locationURL?.searchParams?.get("program_focus"));
    setPreselectedProgramLocation(
      locationURL?.searchParams?.get("program_location")
    );
  }, [location]);

  return (
    <ThemeContext.Consumer>
      {(theme) => (
        <Layout
          pageTitle={page?.title ?? "Application Form"}
          containerClass={"w-full mx-auto application-form"}
          brandingOpts={{ ...theme }}
          stickyFooterDetails={enquireUKCardDetails}
          showMobileStickyFooter={false}
          showGrantsBanner={false}
          showMobileEnquireNow={false}
          showMobileApplyNow={false}
          updateOnScroll={false}
        >
          <div
            className="relative z-0 bg-center bg-no-repeat bg-cover bg-gray-tertiary dark:bg-gray-dark"
            style={{
              backgroundImage: `url('${heroBackgroundImage}')`
            }}
          >
            {isNoProgram && (
              <>
                <div ref={heroRef}>
                  <Hero
                    heroHeadLine={heroOverlayTitle}
                    heroImg={heroBackgroundImage}
                    navLinks={""}
                    videoId={heroBackgroundVideo}
                    heroClass={heroClassName}
                  />
                </div>
                <FindProgramPage
                  groupProgram={groupInstituteSource}
                  preselectedProgramType={preselectedProgramType}
                  preselectedProgramFocus={preselectedProgramFocus}
                  preselectedProgramLocation={preselectedProgramLocation}
                  currencyToUse={theme?.currentSiteMeta?.currency?.toLowerCase()}
                  currencySymbol={theme?.currentSiteMeta?.currency_symbol}
                />
              </>
            )}
            {!isNoProgram && (
              <ApplicationForm
                formStep={appformStep}
                details={details}
                theme={theme}
              />
            )}

            <Newsletter />
          </div>
        </Layout>
      )}
    </ThemeContext.Consumer>
  );
}

export const Head = ({ data }) => {
  const page = data?.page ?? {};
  return (
    <Seo
      title={
        page?.seoLegacy?.title ??
        page?.seo?.title ??
        page.title ??
        "Application Form"
      }
      description={page?.seoLegacy?.description ?? page?.seo?.description}
      image={page?.globalConfig?.backgroundImage?.sourceUrl}
      translations={page?.translations}
      lang={page?.locale}
      meta={[
        {
          name: "robots",
          content: page?.seoLegacy?.robots ?? page?.seo?.robots
        }
      ]}
    />
  );
};

export const pageQuery = graphql`
  query {
    page: wpPage(slug: { eq: "application-form" }) {
      ...WpPageFragment
    }
  }
`;
